import { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CartProvider } from './Cart/CartContext';
import { VoucherProvider } from './Voucher/VoucherContext';
import { clearBookingFlowStorage } from '../Utils/SessionStorage';

const BookingFlowSession = ({ isHome, children }) => {
  const [ready, setReady] = useState(!isHome);

  useLayoutEffect(() => {
    if (isHome) {
      clearBookingFlowStorage();
      setReady(true);
    }
  }, [isHome]);

  useEffect(() => {
    if (isHome && ready) clearBookingFlowStorage();
  }, [isHome, ready]);

  if (!ready) return null;

  return (
    <CartProvider>
      <VoucherProvider>{children}</VoucherProvider>
    </CartProvider>
  );
};

export const BookingFlowProvider = ({ children }) => {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  // Reset all in-memory slices (including timer intervals) at the Home boundary.
  // Keep the same providers across booking steps and on non-Home deep links.
  return (
    <BookingFlowSession key={isHome ? 'home' : 'booking'} isHome={isHome}>
      {children}
    </BookingFlowSession>
  );
};
